import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

// `enabled` (facultatif, 2026-09-29) : 'not-enabled' n'appelle pas le serveur
// (questions d'un attendu d'un autre niveau, demandées seulement dans ce cas).
export const useBanqueQuestions = (filters = {}, refresh, enabled) => {
  let urlfetch = `${url}banque-questions/`;
  const params = Object.entries(filters).filter(([, v]) => v);
  if (params.length > 0) {
    const queryString = params
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    urlfetch += `?${queryString}`;
  }
  return useApi(urlfetch, [], refresh, enabled);
};
